const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/utils/appointment.ts';
import moment from 'moment';
import { SlotDuration } from 'App/defs/types';
import { AppointmentType, StructuredAppointment, TreatmentReason } from '@cistec/common_web/defs/kisim';
import { AppointmentObject } from '@cistec/common_web/defs/notReallyKisim';
import { FormatMessageFn, KISIM_TIME_OPEN } from '@cistec/common_web/defs/generalDefs';
import textMap from 'App/components/AppointementList/translations';
import { convertStructuredAppointmentToAppointmentObject } from '@cistec/common_web/utils/kisim';

export const patAppUserCanSeeAppointment = (
    appointment: StructuredAppointment,
    allowedAppointmentTypes: AppointmentType[]
) => {
    const allowedStatuses = ['A'];

    const hasAllowedType = allowedAppointmentTypes.includes(appointment.TYP!);
    const hasAllowedStatus = allowedStatuses.includes(appointment.STAT!);
    return hasAllowedType && hasAllowedStatus;
};

export const timeRangeToLookForFutureAppointments = () => {
    const mindat = moment().add(-8, 'hours').format('YYYY-MM-DD HH:mm');
    const maxdat = KISIM_TIME_OPEN;
    return { mindat, maxdat };
};

/**
 * This function returns the duration in minutes from the treatmentReason
 * @param treatmentReason as Immutable map
 * @return duration in minutes or undefined
 */
export const getSlotDuration = (treatmentReason: TreatmentReason): number | undefined => {
    const durationString: string = treatmentReason.Duration.Val;
    if (durationString) {
        const durationValue: number = parseInt(durationString, 10);
        switch (treatmentReason.Duration.Unit) {
            case SlotDuration.minutes:
                return durationValue;
            case SlotDuration.hours:
                return durationValue * 60;
            case SlotDuration.days:
                return durationValue * 60 * 24;
            default:
                return undefined;
        }
    }
};

export const getAppointmentObjectTitle = (
    appointmentObject: AppointmentObject,
    formatMessage: FormatMessageFn,
    email?: string
) => {
    const { interventions, patientByEmail, startDat, termLocation, title, typ, resname } = appointmentObject;
    const interventionText = interventions && interventions.length ? interventions[0].name : '';
    const startDay = moment(startDat).format('YYYYMMDD');
    const now = moment().format('YYYYMMDD');

    switch (typ) {
        case 'OPERATION':
            return formatMessage(textMap.operation);
        case 'TRIAGE':
            return formatMessage(textMap.emergency);
        case 'KONS':
        case 'RES':
            return title || interventionText || termLocation;
        case 'BELEGUNG':
            return `${resname}`;
        default:
            return email && patientByEmail === email
                ? formatMessage(textMap.appointmentCreatedByMe)
                : formatMessage(textMap.appointmentDefaultTitle);
    }
};

export const getStructuredAppointmentTitle = (appointment: StructuredAppointment, formatMessage: FormatMessageFn) => {
    const appointmentObject = convertStructuredAppointmentToAppointmentObject(appointment, formatMessage);
    return getAppointmentObjectTitle(appointmentObject, formatMessage);
};
